import ReplaceArrows from '../../src/legacy/ReplaceArrows.tsx';
export default ReplaceArrows;
